export const ownerscabinImageOptions = {
  angle: 'ownerscabin',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    SplitBerth: 1,
    Backrest: 1,
    TableBox: 1,
    Pouffes: 1,
    FabricOwnersCabin: 1,
    FabricAftCabin: 1,
    AftCabinShelving: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'Floorboard',
      dependency: 'Pouffes'
    },
    {
      option: 'CupboardsOwnersCabin',
      dependency: 'Veneer'
    },
    {
      option: 'FabricOwnersCabin',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X46/views/ownerscabin.js